export class OfferStatus {

    id: number = 0;
    description!: string;
    code!: string;

}